/**
 * pan.ts — Categoría "Panadería" (10 productos demo).
 * Algunos son insumos (panes para hamburguesa/hotdog) usados en fast food.
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_pan",
  skuPrefix: "PAN",
  categoria: "Panadería",
} as const;

export const cat_pan_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Pan Hamburguesa x6",
    marca: "Bimbo",
    modelo: "Artesano Sésamo",
    origen: "Colombia",
    costo: 5200,
    precio: 7900,
    stock: 110,
    stockMinimo: 25,
    stockMaximo: 200,
    unidad: "paquete",
    ubicacionFisica: "Estante P1, panadería",
    proveedor: "Bimbo Colombia",
    tiempoEntrega: "Diario",
    vencimientoMeses: 1,
    pesoNeto: "300g",
    descripcionLarga:
      "Paquete de 6 panes para hamburguesa con semillas de sésamo. Miga suave, corteza firme que no se deshace. Ideal para hamburguesas gourmet y caseras.",
    especificaciones: [
      { clave: "Unidades", valor: "6 panes" },
      { clave: "Diámetro", valor: "10 cm" },
    ],
    imageKeywords: ["hamburger-bun", "pan-hamburguesa", "sesame-bun"],
    color: "bg-amber-200",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Pan Hot Dog x8",
    marca: "Bimbo",
    modelo: "Clásico",
    origen: "Colombia",
    costo: 4800,
    precio: 7200,
    stock: 120,
    stockMinimo: 28,
    stockMaximo: 220,
    unidad: "paquete",
    ubicacionFisica: "Estante P1, panadería",
    proveedor: "Bimbo Colombia",
    vencimientoMeses: 1,
    pesoNeto: "320g",
    descripcionLarga:
      "Paquete de 8 panes para hot dog, forma alargada con corte superior. Esponjosos, se adaptan a salchichas de todo tamaño.",
    especificaciones: [
      { clave: "Unidades", valor: "8 panes" },
      { clave: "Largo", valor: "15 cm" },
    ],
    imageKeywords: ["hot-dog-bun", "pan-perro", "sausage-roll"],
    color: "bg-amber-200",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Pan Blanco Tajado Bimbo 680g",
    marca: "Bimbo",
    modelo: "Artesano Blanco",
    origen: "Colombia",
    costo: 6500,
    precio: 9800,
    stock: 95,
    stockMinimo: 20,
    stockMaximo: 180,
    unidad: "paquete",
    ubicacionFisica: "Estante P1, panadería",
    proveedor: "Bimbo Colombia",
    vencimientoMeses: 1,
    pesoNeto: "680g",
    descripcionLarga:
      "Pan blanco tajado esponjoso, 22 tajadas. Versátil para sándwiches, desayunos y tostadas. Rico en energía.",
    especificaciones: [
      { clave: "Tajadas", valor: "22" },
      { clave: "Formato", valor: "Bolsa 680g" },
    ],
    imageKeywords: ["white-bread", "pan-tajado", "sliced-bread"],
    color: "bg-amber-100",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Pan Integral Tajado 500g",
    marca: "Bimbo",
    modelo: "Integral Multicereal",
    origen: "Colombia",
    costo: 6800,
    precio: 10400,
    stock: 80,
    stockMinimo: 18,
    stockMaximo: 160,
    unidad: "paquete",
    ubicacionFisica: "Estante P1, panadería",
    proveedor: "Bimbo Colombia",
    vencimientoMeses: 1,
    pesoNeto: "500g",
    descripcionLarga:
      "Pan integral con multicereales y semillas. Alto en fibra, bajo en azúcar. Ideal para dietas saludables y desayunos energéticos.",
    especificaciones: [
      { clave: "Fibra", valor: "3g por tajada" },
      { clave: "Cereales", valor: "Avena, linaza, quinoa" },
    ],
    imageKeywords: ["whole-wheat-bread", "integral", "seed-bread"],
    color: "bg-amber-800",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Pan Francés Baguette",
    marca: "Panadería Don Jacobo",
    origen: "Colombia",
    costo: 2800,
    precio: 4500,
    stock: 65,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "unidad",
    ubicacionFisica: "Estante P1, panadería",
    proveedor: "Panadería Don Jacobo",
    vencimientoMeses: 1,
    pesoNeto: "250g",
    descripcionLarga:
      "Baguette artesanal horneado a leña. Corteza crujiente, miga aireada. Ideal para bruschettas, sándwiches y acompañante de pastas.",
    especificaciones: [
      { clave: "Largo", valor: "60 cm" },
      { clave: "Estilo", valor: "Francés tradicional" },
    ],
    imageKeywords: ["baguette", "french-bread", "artisan-bread"],
    color: "bg-amber-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Tortilla de Trigo Tía Rosa x10",
    marca: "Tía Rosa",
    modelo: "Grande",
    origen: "Colombia",
    costo: 5500,
    precio: 8500,
    stock: 85,
    stockMinimo: 18,
    stockMaximo: 160,
    unidad: "paquete",
    ubicacionFisica: "Estante P1, panadería",
    proveedor: "Grupo Bimbo Colombia",
    vencimientoMeses: 2,
    pesoNeto: "500g",
    descripcionLarga:
      "Tortillas de harina de trigo grandes, flexibles y suaves. Ideales para burritos, quesadillas y wraps.",
    especificaciones: [
      { clave: "Unidades", valor: "10" },
      { clave: "Diámetro", valor: "25 cm" },
    ],
    imageKeywords: ["tortilla", "wrap", "flour-tortilla"],
    color: "bg-amber-100",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Croissant Mantequilla",
    marca: "Panadería Don Jacobo",
    origen: "Colombia",
    costo: 2400,
    precio: 3800,
    stock: 55,
    stockMinimo: 12,
    stockMaximo: 110,
    unidad: "unidad",
    ubicacionFisica: "Vitrina P2, productos frescos",
    proveedor: "Panadería Don Jacobo",
    vencimientoMeses: 1,
    pesoNeto: "80g",
    descripcionLarga:
      "Croissant horneado con mantequilla 82%, hojaldrado múltiples capas. Dorado por fuera, tierno por dentro. Perfecto con café.",
    especificaciones: [
      { clave: "Mantequilla", valor: "82%" },
      { clave: "Capas", valor: "27" },
    ],
    imageKeywords: ["croissant", "french-pastry", "butter"],
    color: "bg-amber-400",
    shape: "diamond",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Pandebono x6",
    marca: "Panadería Don Jacobo",
    origen: "Colombia",
    costo: 3200,
    precio: 5000,
    stock: 70,
    stockMinimo: 15,
    stockMaximo: 140,
    unidad: "paquete",
    ubicacionFisica: "Vitrina P2, productos frescos",
    proveedor: "Panadería Don Jacobo",
    vencimientoMeses: 1,
    pesoNeto: "240g",
    descripcionLarga:
      "Pandebono clásico colombiano elaborado con queso costeño, almidón de yuca y huevos. Crujiente por fuera, elástico por dentro.",
    especificaciones: [
      { clave: "Unidades", valor: "6" },
      { clave: "Ingrediente base", valor: "Queso costeño" },
    ],
    imageKeywords: ["pandebono", "cheese-bread", "colombian-bread"],
    color: "bg-amber-300",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Almojábana x6",
    marca: "Panadería Don Jacobo",
    origen: "Colombia",
    costo: 3000,
    precio: 4700,
    stock: 70,
    stockMinimo: 15,
    stockMaximo: 140,
    unidad: "paquete",
    ubicacionFisica: "Vitrina P2, productos frescos",
    proveedor: "Panadería Don Jacobo",
    vencimientoMeses: 1,
    pesoNeto: "240g",
    descripcionLarga:
      "Almojábana tradicional santafereña con queso campesino fresco. Perfecta para desayuno con chocolate caliente.",
    especificaciones: [
      { clave: "Unidades", valor: "6" },
      { clave: "Sabor", valor: "Tradicional" },
    ],
    imageKeywords: ["almojabana", "colombian-bread", "cheese-bun"],
    color: "bg-amber-200",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Brownie Chocolate",
    marca: "Panadería Don Jacobo",
    origen: "Colombia",
    costo: 2800,
    precio: 4500,
    stock: 50,
    stockMinimo: 12,
    stockMaximo: 100,
    unidad: "unidad",
    ubicacionFisica: "Vitrina P2, productos frescos",
    proveedor: "Panadería Don Jacobo",
    vencimientoMeses: 1,
    pesoNeto: "90g",
    descripcionLarga:
      "Brownie de chocolate belga, textura fudge y trozos de nuez. Endulzado con panela. Postre insignia de la casa.",
    especificaciones: [
      { clave: "Chocolate", valor: "Belga 54%" },
      { clave: "Nuez", valor: "Sí" },
    ],
    imageKeywords: ["brownie", "chocolate-dessert", "cake"],
    color: "bg-amber-900",
    shape: "square",
  }),
];
